import * as React from 'react'
import ReactPlayer from 'react-player/vimeo'

import { containerStyles } from '../../styles/ContainerStyles'

type Props = {
    videoUri: string
    autoplay?: boolean
}

export const VideoPlayer: React.FC<Props> = ({ videoUri, autoplay = false }) => {
    const styles = containerStyles()
    const playerRef = React.useRef<ReactPlayer>(null)
    const durationRef = React.useRef<number>(0)

    const handleVideoEnd = () => {
        // Seek back slightly so the last frame stays visible instead of fading to black
        if (playerRef.current && durationRef.current > 0) {
            playerRef.current.seekTo(durationRef.current - 0.5, 'seconds')
        }

        // Exit fullscreen when video ends
        if (document.fullscreenElement) {
            document.exitFullscreen()
        } else if ((document as any).webkitFullscreenElement) {
            (document as any).webkitExitFullscreen()
        } else if ((document as any).mozFullScreenElement) {
            (document as any).mozCancelFullScreen()
        } else if ((document as any).msFullscreenElement) {
            (document as any).msExitFullscreen()
        }
    }

    const handleDuration = (duration: number) => {
        durationRef.current = duration
    }

    return (
        <div className={styles.videoPlayerContainer}>
            <ReactPlayer
                ref={playerRef}
                url={videoUri}
                width="100%"
                height="100%"
                controls
                playing={autoplay}
                onEnded={handleVideoEnd}
                onDuration={handleDuration}
                config={{
                    playerOptions: {
                        outro: 'nothing',
                    },
                }} />
        </div>
    )
}
